import { Controller } from "stimulus";

export default class extends Controller {
    
    connect() {
        // im erbenden Controller hier super.connect() aufrufen!
        this._onSubmit = (event) => {
            const submitButton = this.element.querySelector(`button[type="submit"]`)
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.textContent = window.translate && window.translate("Bitte warten...") || "Please wait...";
            }
        };
        this.form.addEventListener("submit", this._onSubmit);
    }

    disconnect() {
        // im erbenden Controller hier super.disconnect() aufrufen!
        this.form.removeEventListener("submit", this._onSubmit);
    }

    get form() {
        if (this._form === void 0) {
            let form = this.element;
            if (form.nodeName !== "FORM") {
                form = form.querySelector("form");
            }
            if (form) {
                this._form = form;
            }
        }
        return this._form;
    }
}